import React, { useEffect, useState } from "react";
import {
  useTheme,
  TextField,
  IconButton,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Tabs,
  Tab,
  Box,
  Button,
  InputAdornment,
  Skeleton
} from "@mui/material";
import Fade from '@mui/material/Fade';
import { tokens } from "../theme";
import axios from "axios";
import Cookies from "js-cookie";
import Header from "../Components/Header";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import useMediaQuery from "@mui/material/useMediaQuery";
import Tooltip from '@mui/material/Tooltip';
import baseURL from "../config";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import SearchIcon from '@mui/icons-material/Search';
import CryptoJS from "crypto-js";
import RecordsTable from "../Components/RecordsTable";

const CustomerGroup = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [filteredCustomerGroupData, setFilteredCustomerGroupData] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedCustomerGroup, setSelectedCustomerGroup] = useState(null);
  const isNonMobile = useMediaQuery("(min-width:620px)");
  const [isLoading, setIsLoading] = useState(true);

  const [customerGroupData, setCustomerGroupData] = useState({
    customerGroupId: 0,
    name: "",
    limit: 0,
    discountPercentage: 0,
  });

  const [tabValue, setTabValue] = useState(0);
  const getDecryptedToken = () => {
    const encryptedToken = Cookies.get("token");
    if (!encryptedToken) return null;

    const secretKey = '19092002'; 
    const bytes = CryptoJS.AES.decrypt(encryptedToken, secretKey);
    const decryptedToken = bytes.toString(CryptoJS.enc.Utf8);

    return decryptedToken || null;
  };

 
  const token = getDecryptedToken();
  const [searchQuery, setSearchQuery] = useState("");

  const fetchCustomerGroups = async () => {
    try {
      const response = await axios.get(`${baseURL}/api/CustomerGroup/GetCustomerGroups`, {
        
      });
      if (response.data) {
        const customerGroups = response.data;
        setIsLoading(false);
        setFilteredCustomerGroupData(customerGroups);
      } else {
        toast.error("Failed to fetch Customer Groups: Success flag is false.");
      }
    } catch (error) {
      toast.error(`Error fetching Customer Group data: ${error.message}`);
    }
  };

  useEffect(() => {
    fetchCustomerGroups();
  }, []);

  const fetchCustomerGroup = async (customerGroupId) => {
    try {
      const response = await axios.get(`${baseURL}/api/CustomerGroup/GetCustomerGroupById`, {
        params: { id: customerGroupId },
      });
      if (response.data) {
        setCustomerGroupData(response.data);
        setDialogOpen(true);
      } else {
        toast.error("Failed to fetch Customer Group: Success flag is false.");
      }
    } catch (error) {
      toast.error(`Error fetching Customer Group: ${error.message}`);
    }
  };

 



  const handleEdit = (event) => {
    const { name, value } = event.target;
    setCustomerGroupData((prevData) => ({ ...prevData, [name]: value }));
  };



 
  const handleSave = async () => {
    if (!customerGroupData.limit || !customerGroupData.discountPercentage || !customerGroupData.name) {
      toast.error("Please fill in all fields.");
      return;
    }
 
    
    try {
      const response = await axios.post(
        `${baseURL}/api/CustomerGroup/UpdateCustomerGroup`,
        customerGroupData
      );
      if (response.status === 200) {
        toast.success("Customer Group u përditësua me sukses!");
        await fetchCustomerGroups();
        setDialogOpen(false);
      } else {
        toast.error("Failed to update Customer Group.");
      }
    } catch (error) {
      toast.error(`Error updating Customer Group: ${error.message}`);
    }
  };
  

 

  const handleSearch = (event) => {
    setSearchQuery(event.target.value.toLowerCase());
  };
  
  const filteredData = filteredCustomerGroupData.filter((group) => {
    const name = group.name?.toLowerCase() || ""; 
    const limit = group.limit?.toString() || ""; // Convert limit to string
    const discount = group.discountPercentage?.toString() || ""; // Convert discount to string
  
    return (
      name.includes(searchQuery) ||
      limit.includes(searchQuery) ||
      discount.includes(searchQuery)
    );
  });
  
  

  const desktopColumns = [
    {
      field: "customerGroupId",
      headerName: "ID",
      flex: 0.35,
      headerClassName: 'super-app-theme--header',
      renderCell: (params) => <span className="table-muted">#{params.value}</span>,
    },
    {
      field: "name",
      headerName: "Name",
      flex: 1,
      headerClassName: 'super-app-theme--header',
      renderCell: (params) => <span className="table-strong">{params.value || "N/A"}</span>,
    },
    {
      field: "limit",
      headerName: "Spending Limit",
      flex: 1,
      headerClassName: 'super-app-theme--header',
      renderCell: (params) => <span className="table-pill">{Number(params.value || 0).toFixed(2)} €</span>,
    },
    {
      field: "discountPercentage",
      headerName: "Discount",
      flex: 1,
      headerClassName: 'super-app-theme--header',
      renderCell: (params) => <span className="table-pill danger">{params.value || 0}%</span>,
    },
    {
      field: "Actions",
      headerName: "",
      headerClassName: 'super-app-theme--header',
      flex: 0.35,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <IconButton
          onClick={() => fetchCustomerGroup(params.row.customerGroupId)}
          className="table-action-button"
          aria-label="Edit customer group"
        >
          <DriveFileRenameOutlineIcon />
        </IconButton>
    //     <IconButton
    //     onClick={() => DeleteCustomerGroup(params.row.customerGroupId)}
    //     sx={{ ml: -1.2 }}
    //   >
    //     <DriveFileRenameOutlineIcon />
    //   </IconButton>
      ),
    },
  ];

  const mobileColumns = [
    {
      field: "name",
      headerName: "Name",
      flex: 1,
      headerClassName: 'super-app-theme--header',
      renderCell: (params) => <span className="table-strong">{params.value || "N/A"}</span>,
    },
    {
      field: "discountPercentage",
      headerName: "Discount",
      flex: 1,
      headerClassName: 'super-app-theme--header',
      renderCell: (params) => <span className="table-pill danger">{params.value || 0}%</span>,
    },
    {
      field: "Actions",
      headerName: "",
      headerClassName: 'super-app-theme--header',
      flex: 0.45,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <IconButton
          onClick={() => fetchCustomerGroup(params.row.customerGroupId)}
          className="table-action-button"
          aria-label="Edit customer group"
        >
          <DriveFileRenameOutlineIcon />
        </IconButton>
      ),
    },
  ];

  const columns = isNonMobile ? desktopColumns : mobileColumns
  return (
    <Box m="10px">
      <Header title="Customer Group" subtitle="Detajet e grupeve te klienteve" />
      <ToastContainer />
      <Box mb={2} display="flex" justifyContent="flex-start">
        <TextField
          label="Search"
          variant="outlined"
          onChange={handleSearch}
          sx={{ backgroundColor: colors.primary[600], width: isNonMobile ? "30%" : "50%" }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
        
      <Link to="/customergroupForm" style={{ textDecoration: "none" }}>
        <Button
          variant="contained"
          sx={{ backgroundColor: colors.primary[700], marginLeft: "20px", marginTop: "8px"}}
        >
          Shto Customer Group
        </Button>
      </Link>
      </Box>
        
      <Box
        m="10px 0 0 0"
        sx={{
          "& .MuiDataGrid-root": { border: "none" },
          "& .MuiDataGrid-cell": { borderBottom: "none" },
          "& .name-column--cell": { color: "#3b0a45" },
          "& .MuiDataGrid-columnHeaders": {
           background: "black",
            borderBottom: "none",
             color: "#ffffff"
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[500],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.primary[800],
            color: "#ffffff"
           
          },
          "& .MuiButton-root": { color: "#ffffff" },
          "& .super-app-theme--header": {
            backgroundColor: colors.primary[200],
          },
          "& .MuiToolbar-root":{color :"#ffffff"},
          "&. MuiTablePagination-actions": {color: "white"}

        }}
      >
      <div style={{ width: "100%" }}>

      {isLoading ? (
         
         <Skeleton
           variant="rectangular"
           width="100%"
           height={500}
           animation="wave"
         />
       ) : (
        <RecordsTable
          columns={columns}
          rows={filteredData}
          getRowId={(row) => row.customerGroupId}
          onRowDoubleClick={(params) => fetchCustomerGroup(params.row.customerGroupId)} 
          emptyMessage="No customer groups match your search."
        />
       )}
     </div>
      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
        
        <DialogContent
            className="custom-dialog-size"
            sx={{ backgroundColor: colors.primary[500], height: isNonMobile ? "" : "50vh",}}
          >
            <div className="tabs-container">
                <Tabs
                  variant="scrollable"
                  scrollButtons="auto"
                  value = {tabValue}  
                >
                  <Tab
                    label="Info per Customer Group"
                    sx={{
                      color: "white",
                      backgroundColor: colors.primary[900],
                      margin: "2px",
                      borderRadius: "5px",
                  
                    }}
                  />
                  </Tabs>
              </div>
              <div
                    style={{
                      margin: "10px",
                      textAlign: "center",
                      display: isNonMobile ? undefined : "flex",
                      flexDirection: isNonMobile ? "row" : "column",
                    }}
                  >

          
            <TextField
              label="Customer Group ID"
              name="customerGroupId"
              value={customerGroupData.customerGroupId}
              onChange={handleEdit}
              fullWidth
              margin="dense"
            />
            <TextField
              label="Name"
              name="name"
              value={customerGroupData.name}
              onChange={handleEdit}
              fullWidth
              margin="dense"
            />
            <TextField
              label="Spending Limit"
              name="limit"
              value={customerGroupData.limit}
              onChange={handleEdit}
              fullWidth
              margin="dense"
            />
            <TextField
              label="Discount Percentage"
              name="discountPercentage"
              value={customerGroupData.discountPercentage}
              onChange={handleEdit}
              fullWidth
              margin="dense"
              />
          </div>
        <DialogActions className="custom-dialog-background">
                <Button
                  onClick={() => setDialogOpen(false)}
                  sx={{ backgroundColor: "white" }}
                  >
                  Cancel
                </Button>
                <Button
                  onClick={handleSave}
                  sx={{ backgroundColor: "white" }}
                  >
                  Save
                </Button>
              </DialogActions>
               </DialogContent>    
                </Dialog>
      </Box>
    </Box>
  );
};

export default CustomerGroup;
